import React, { FC, useState } from 'react';

import { Add } from '@mui/icons-material';
import { Box, Button, Container, Grid, Typography, Badge } from '@mui/material';
import { Helmet } from 'react-helmet';

import { SubmissionList } from '../../components/community/submissions/SubmissionList';
import { NewProposalModal } from '../../components/community/voting/NewProposalModal';
import { useAnalytics } from '../../hooks/dataTracking/useAnalytics';
import { useAuthStore } from '../../stores/auth';

export const MyProposalsPage: FC = () => {
  const user = useAuthStore((store) => store.user);
  const { sendButtonClickTrackingEvent } = useAnalytics();

  const [newProposalModalOpen, setNewProposalModalOpen] = useState<boolean>(false);

  const localProposalItem = localStorage.getItem('proposalForm');
  return (
    <>
      <Helmet>
        <title>My Proposals | Pegaxy Themis</title>
      </Helmet>
      <NewProposalModal open={newProposalModalOpen} handleClose={() => setNewProposalModalOpen(false)} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pb: 6,
          pt: 8,
        }}
      >
        <Container maxWidth={'lg'}>
          <Box sx={{ mb: 4 }}>
            <Grid container justifyContent="space-between" spacing={3} sx={{ px: 2, mb: 3 }}>
              <Grid item>
                <Typography variant="h4">My Proposals</Typography>
              </Grid>
              <Grid item>
                <Badge badgeContent="💾" color="error" invisible={!localProposalItem}>
                  <Button
                    disabled={!user}
                    fullWidth
                    variant="contained"
                    startIcon={<Add />}
                    onClick={() => {
                      sendButtonClickTrackingEvent('Open new proposal form');
                      setNewProposalModalOpen(true);
                    }}
                  >
                    Submit Proposal
                  </Button>
                </Badge>
              </Grid>
            </Grid>
            <Box sx={{ p: 2 }}>
              <Grid container spacing={2}>
                <Grid item lg={12} sm={12} xs={12}>
                  <SubmissionList setNewProposalModalOpen={setNewProposalModalOpen} />
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};
